import { Component, OnInit } from '@angular/core';
import { ServerService } from 'src/app/services/server.service';
import { ClipBoardService } from '../../services/clipboard.service'
import { ClientLeadInfoModalComponent } from '../client-lead/client-lead-info-modal/client-lead-info-modal.component';
import { MatDialog, MatPaginator, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material';
import { CallLogsFilterModalComponent } from './call-logs-filter-modal/call-logs-filter-modal.component';
@Component({
  selector: 'app-call-logs',
  templateUrl: './call-logs.component.html',
  styleUrls: ['./call-logs.component.scss']
})
export class CallLogsComponent implements OnInit {
  authToken = localStorage.getItem('token');
  callLogs:any;
  leadInfoModalComponent: MatDialogRef<ClientLeadInfoModalComponent>;
  callLogsFilterModalComponent: MatDialogRef<CallLogsFilterModalComponent>;
  showComponentLoader: boolean = false
  pageIndex: number = 0;
  pageSize: number = 100;
  total_count:any;
  elasticSearch: any = ""
  filteredLogs: any[] = []
  logs: any[] = [];
  selectedProject: any = ''
  selectedUser: any = '';
  createdAt:any;
  constructor(
    private serverservice:ServerService,
    private dialog: MatDialog,
    private clipBoardService:ClipBoardService
  ) { }

  ngOnInit() {
    this.getAllCallLogs();
  }
  getAllCallLogs(){
    let body = {}
    if(this.elasticSearch.trim() != ''){
      body['to_number'] = this.elasticSearch;
    }
    if (this.selectedProject != "") {
      body["project_id"] = this.selectedProject;
    }
    if (this.selectedUser != "") {
      body["user_id"] = this.selectedUser;
    }
    if (this.createdAt != undefined && this.createdAt != "") {
      body["created_at"] = [this.createdAt.formatted.split(" - ")[0], this.createdAt.formatted.split(" - ")[1]];
    }
    this.showComponentLoader = true;
    let url = "per_page=100&page=1"
    this.serverservice.getAllCallLogs(url,body,this.authToken).subscribe((data)=>{
      this.callLogs = data.calls;
     this.total_count = data.pagination.total_count;
    })
  }
  leadInfo(lead_id,project_id){
    let leadInfo = {
      'id': lead_id,
      'project_id':project_id
    }
    this.leadInfoModalComponent = this.dialog.open(ClientLeadInfoModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '500px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: leadInfo
    });
    this.serverservice.getLeadDetailById(leadInfo,this.authToken).subscribe((data)=>{
    })
  }
  getNext(event) {
    let body = {};
    if(this.elasticSearch.trim() != ''){
      body['to_number'] = this.elasticSearch
    }
    if (this.selectedProject != "") {
      body["project_id"] = this.selectedProject;
    }
    if (this.selectedUser != "") {
      body["user_id"] = this.selectedUser;
    }
    if (this.createdAt != undefined && this.createdAt != "") {
      body["created_at"] = [this.createdAt.formatted.split(" - ")[0], this.createdAt.formatted.split(" - ")[1]];
    }
    this.showComponentLoader = true
    let body1 = {
      "per_page": event.pageSize,
      "page": event.pageIndex
    };
    this.pageSize = body1.per_page;
    this.pageIndex = body1.page
    let indexPage = this.pageIndex + 1
    let url = "per_page=" + body1.per_page + "&page=" + indexPage
    this.serverservice.getAllCallLogs(url,body,this.authToken).subscribe(
      data => {
        this.callLogs = data.calls
        this.showComponentLoader = true
      },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }
  removeSearch(){
    this.elasticSearch = '';
  }
  filter(){
    let body = {};
    if (this.selectedProject != undefined && this.selectedProject != "") {
      body['selectedProject'] = this.selectedProject
    }
    if (this.selectedUser != undefined && this.selectedUser != "") {
      body['selectedUser'] = this.selectedUser
    }
    if (this.createdAt != undefined && this.createdAt != "") {
      body["createdAt"] = this.createdAt
    }
    this.callLogsFilterModalComponent = this.dialog.open(CallLogsFilterModalComponent,{
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '500px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: body
    }) 
    this.callLogsFilterModalComponent.afterClosed().subscribe((result)=>{
      if(result != undefined){
      // console.log(result);
      if (result.selectedProject != undefined && result.selectedProject != "") {
        this.selectedProject = result.selectedProject
      } else {
        this.selectedProject = ""
      }
      if (result.selectedUser != undefined && result.selectedUser != "") {
        this.selectedUser = result.selectedUser
      } else {
        this.selectedUser = ""
      }
      if (result.createdAt != undefined && result.createdAt != "") {
        this.createdAt = result.createdAt
      } else {
        this.createdAt = ""
      }
      this.getAllCallLogs();
    }
    })
  }
}
